export const GTM_ID = "GTM-52T8RVLG";
